import { render, staticRenderFns } from "./PageImage.vue?vue&type=template&id=cd2b3a72&scoped=true&"
import script from "./PageImage.vue?vue&type=script&lang=js&"
export * from "./PageImage.vue?vue&type=script&lang=js&"
import style0 from "./PageImage.vue?vue&type=style&index=0&id=cd2b3a72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2b3a72",
  null
  
)

export default component.exports